import { useToast } from "hooks/useToast";
import {
  useAddS174EntryMutation,
  useUpdateS174EntryMutation,
} from "store/apis/estimatedTax";
import { S174Entry } from "types/Models/estimatedTax";
import { BackendError } from "types/utils/error";
import { S174EntryFormModal, S174Form } from "./S174EntryFormModal";

type Props = {
  open: boolean;
  onClose: () => void;
  entityId: string;
  entry?: S174Entry | null;
};

export const AddS174EntryModal = ({
  open,
  onClose,
  entityId,
  entry,
}: Props) => {
  const { alertToast, successToast } = useToast();
  const [addEntry, { isLoading: isAdding }] = useAddS174EntryMutation();
  const [updateEntry, { isLoading: isUpdating }] = useUpdateS174EntryMutation();

  const isLoading = isAdding || isUpdating;
  const initialValues: S174Form = {
    period_year: entry ? String(entry.period_year) : "",
    amount: entry ? String(entry.amount) : "",
  };

  const handleSubmit = async (values: S174Form) => {
    const payload = {
      period_year: Number(values.period_year),
      amount: Number(values.amount),
    };

    try {
      if (entry) {
        await updateEntry({ entityId, entryId: entry.id, payload }).unwrap();
        successToast({ message: "R&D expense entry updated" });
      } else {
        await addEntry({ entityId, payload }).unwrap();
        successToast({ message: "R&D expense entry added" });
      }
      onClose();
    } catch (e) {
      alertToast({
        message:
          (e as BackendError)?.data?.error?.message ||
          "Failed to save R&D expense entry",
      });
    }
  };

  return (
    <S174EntryFormModal
      open={open}
      onClose={onClose}
      initialValues={initialValues}
      title={entry ? "Edit R&D expense entry" : "Add R&D expense entry"}
      submitLabel={entry ? "Save changes" : "Add entry"}
      isLoading={isLoading}
      onSubmit={handleSubmit}
    />
  );
};
